export const plans = [
  {
    name: 'Base',
    index: 'base',
    price: '$12/mo',
    users: '1 User',
    features: ['Lead Tracking', 'Lead Analytics'],
    isCurrent: false,
  },
  {
    name: 'Starter',
    index: 'starter',
    price: '$20/mo',
    users: 'Up to 3 Users',
    features: [
      'Everything in Base Package',
      'AI Suggestions',
      // 'Email Marketing',
      // 'WhatsApp Messaging',
      'Notifications',
      'Task Allocation',
      // 'Invoicing',
      'Quotes',
    ],
    isCurrent: false,
  },
  {
    name: 'Pro',
    index: 'pro',
    price: '$35/mo',
    users: 'Up to 5 Users',
    features: [
      'AI Suggestions',
      // 'Email Marketing',
      // 'WhatsApp Messaging',
      'Notifications',
      'Task Allocation',
      // 'Invoicing',
      'Quotes',
    ],
    isCurrent: false,
  },
  // {
  //   name: 'Enterprise',
  //   index: 'ent',
  //   price: 'Custom',
  //   users: 'Unlimited Users',
  //   features: [
  //     'Everything in Business',
  //     'Custom CRM Features',
  //     'Dedicated Manager',
  //     '24/7 Priority Support',
  //   ],
  //   contact: 'saleradius@gmail.com',
  //   isCurrent: false,
  // },
];
